exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.EditorCanvas[data-v-1c0bf918] {\n  transition: all 0.3s;\n  cursor: crosshair;\n}\n", ""]);

// exports
